import { CometChatCalls } from "@cometchat/calls-sdk-javascript";
import {
  cometChatAppId,
  cometChatAuthKey,
  cometChatRegion,
} from "../config";

const APP_ID = cometChatAppId;
const REGION = String(cometChatRegion || "in").toUpperCase() as
  | "IN"
  | "US"
  | "EU"
  | "in"
  | "us"
  | "eu";
const AUTH_KEY = cometChatAuthKey;

let callsReadyPromise: Promise<void> | null = null;

const initCallsSdk = (): Promise<void> => {
  if (callsReadyPromise) {
    return callsReadyPromise;
  }

  callsReadyPromise = (async () => {
    try {
      const result = await CometChatCalls.init({
        appId: APP_ID,
        region: REGION,
        authKey: AUTH_KEY,
      });
      if (result && typeof result === "object" && "error" in result && result.error) {
        throw result.error;
      }
      console.log("CometChatCalls initialized successfully");
    } catch (error) {
      console.log("CometChatCalls init failed:", error);
      callsReadyPromise = null;
      throw error;
    }
  })();

  return callsReadyPromise;
};

void initCallsSdk();

/** Resolves when CometChat Calls SDK has finished initializing. */
export const whenCometChatCallsReady = (): Promise<void> => {
  if (callsReadyPromise) {
    return callsReadyPromise;
  }
  return initCallsSdk();
};

export const logoutCometUser = async () => {
  try {
    await CometChatCalls.logout();
    console.log("Calls SDK logout completed successfully");
  } catch (error) {
    console.log("Calls SDK logout failed:", error);
  }
};
